import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import SliderComponent from "./sliderComponent.js"
import { buildSeatLabel, seatDefault } from "../moreFiltersContainer/seatFilterConfig"

class SeatInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentRange: this.props.currentRange,
      labelRange: this.props.currentRange
    }
  }

  componentDidMount() {
    //we might grab the URL here on mount. but I don't know if we should or not.
    //might pass these down as defaultValue props.
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentRange !== this.props.currentRange) {
      if (this.props.currentRange !== this.state.currentRange) {
        this.setState({
          currentRange: this.props.currentRange,
          labelRange: this.props.currentRange
        })
      }
    }
  }

  handleLabelChange = values => {
    this.setState({
      labelRange: values
    })
  }

  handleSeatChange = values => {
    this.setState({
      currentRange: values
    })
    this.props.onChange(values)
  }

  render() {
    const { currentRange, labelRange } = this.state
    
    const { showFeedbackLabel, defaultMax, defaultMin } = this.props

    return (
      <React.Fragment>
        {showFeedbackLabel && (
          <div className="slider-label">
            {buildSeatLabel(labelRange)}
          </div>
        )}
        <SliderComponent
          domain={[defaultMin, defaultMax]}
          currValues={currentRange}
          onUpdate={this.handleLabelChange}
          steps={1}
          onSlideEnd={this.handleSeatChange}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(SeatInput)

SeatInput.defaultProps = {
  showFeedbackLabel: true,
  defaultMin: seatDefault[0],
  defaultMax: seatDefault[1],
  defaultLabel: "Seat Height",
  currentRange: [seatDefault[0], seatDefault[1]],
  onChange: function() {}
}
